import { MyComponentChildren } from '../types/dataTypes';
import React from 'react';

const ClientLayout = ({ children }: MyComponentChildren) => {
  return <div>{children}</div>;
};

export default ClientLayout;
